import React from 'react';
import { SamlLoginForm } from 'views/components/organisms/SamlLoginForm';

type SAMLLoginPageLayoutProps = {
  errorMessage?: string;
  disabled?: boolean;
  onSamlLogin(enterpriseName: string): void;
};

export const SAMLLoginPageLayout: React.FC<SAMLLoginPageLayoutProps> = ({
  errorMessage,
  disabled,
  onSamlLogin,
}) => {
  return (
    <SamlLoginForm
      onSamlLogin={onSamlLogin}
      errorMessage={errorMessage}
      disabled={disabled}
    />
  );
};
